import { ReactElement } from 'react';
import { Tab } from '@mui/material';

import NewFeatureBagde from '../../NewFeatureBagde';

import AccessFeatureNextPlanChip from '../NextPlanChip';

import { AccessFeatureTabProps } from './types';

const AccessFeatureTab = ({
  validFeature,
  availableToDate,
  icon,
  iconPosition = 'end',
  newActiveForVersion,
  ...restProps
}: AccessFeatureTabProps): ReactElement => (
  <Tab
    icon={
      <div>
        {icon}

        {newActiveForVersion && (
          <NewFeatureBagde activeForVersion={newActiveForVersion} />
        )}

        <AccessFeatureNextPlanChip
          validFeature={validFeature}
          availableToDate={availableToDate}
        />
      </div>
    }
    iconPosition={iconPosition}
    {...restProps}
  />
);

export default AccessFeatureTab;
